import type { RequestFn } from '../http';

export type TicketSenderTriageStatus =
  | 'AUTO_ASSIGNED'
  | 'SUGGESTED'
  | 'NEEDS_REVIEW'
  | 'MANUAL_ASSIGNED'
  | 'DISMISSED';

export interface TicketSenderTriageItem {
  id: string;
  ticketId: string;
  ticketNumber: string | null;
  subject: string | null;
  senderEmail: string | null;
  senderName: string | null;
  status: TicketSenderTriageStatus;
  confidence: number | null;
  matchMethod: string | null;
  suggestedCustomerId: string | null;
  suggestedCustomerName: string | null;
  kianReasoning: string | null;
  createdAt: string;
  updatedAt: string;
}

export function createTicketSenderTriageApi(request: RequestFn) {
  return {
    async getTicketSenderTriage(status: 'OPEN' | 'NEEDS_REVIEW' | 'SUGGESTED' | 'ALL' = 'OPEN', limit = 100) {
      const params = new URLSearchParams({ status, limit: String(limit) });
      return request<{ items: TicketSenderTriageItem[] }>(`/admin/ticket-sender-triage?${params}`);
    },

    async assignTicketSenderTriage(
      id: string,
      data: {
        customerId: string;
        senderEmail?: string;
        contactName?: string;
        createContact?: boolean;
        closeTicket?: boolean;
        closeComment?: string;
      }
    ) {
      return request<{
        success: true;
        contactId: string | null;
        customerName: string;
        closed?: boolean;
        closeWarning?: string | null;
      }>(`/admin/ticket-sender-triage/${encodeURIComponent(id)}/assign`, {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },

    async dismissTicketSenderTriage(id: string) {
      return request<{ success: true }>(`/admin/ticket-sender-triage/${encodeURIComponent(id)}/dismiss`, {
        method: 'POST',
      });
    },
  };
}
